import React from 'react';
import { styled } from '@mui/material/styles';

export const ErrorImg = styled('img')(() => ({
	maxWidth: '100%',
	width: 560,
	maxHeight: 300,
	height: 'auto',
}));
